import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  HomeIcon, 
  ChevronRightIcon, 
  MagnifyingGlassIcon, 
  PlusIcon, 
  FunnelIcon, 
  ChevronDownIcon, 
  AdjustmentsHorizontalIcon, 
  XMarkIcon, 
  ArrowLeftIcon, 
  FireIcon,
  UserPlusIcon,
  EyeIcon,
  CheckCircleIcon,
  ClockIcon,
  SparklesIcon,
  UserIcon,
  BuildingOfficeIcon,
  TruckIcon,
  CalendarDaysIcon,
  DocumentTextIcon,
  ArrowRightIcon,
  TrashIcon
} from '@heroicons/react/24/outline';
import api from '../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api
import { toast } from 'react-toastify';
import '../styles/dashboard.css';
import LeadModals from '../components/LeadModals';

const LeadPage = () => {
  const navigate = useNavigate();
  // Solo l'admin può eliminare le lead
  const isAdmin = (() => {
    try { const u = JSON.parse(localStorage.getItem('user')); return String(u?.role || u?.ruolo || '').toLowerCase() === 'admin'; }
    catch (e) { return false; }
  })();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [originFilter, setOriginFilter] = useState('');
  const [sourceFilter, setSourceFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [temperatureFilter, setTemperatureFilter] = useState('');
  const [totalResults, setTotalResults] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);

  // Stati per la modale di creazione lead
  const [showLeadModal, setShowLeadModal] = useState(false);
  
  // Stati per la modale di creazione cliente
  const [showClientModal, setShowClientModal] = useState(false);
  const [clientFormData, setClientFormData] = useState({
    tipo_cliente: 'privato',
    nome: '',
    cognome: '',
    ragione_sociale: '',
    codice_fiscale: '',
    partita_iva: '',
    email: '',
    telefono: '',
    indirizzo: '',
    citta: '',
    cap: '',
    provincia: '',
    note: ''
  });
  const [loadingClientCreation, setLoadingClientCreation] = useState(false);
  
  // Stati per la modale di dettaglio lead
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  
  // Stati per l'assegnazione alle agenzie
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [agenzieDisponibili, setAgenzieDisponibili] = useState([]);
  const [selectedAgenzia, setSelectedAgenzia] = useState('');
  const [noteAssegnazione, setNoteAssegnazione] = useState('');
  const [loadingAssegnazione, setLoadingAssegnazione] = useState(false);
  const [agenzieSearchTerm, setAgenzieSearchTerm] = useState('');
  const [agenzieOrderBy, setAgenzieOrderBy] = useState('nome');
  
  const [step, setStep] = useState(1);
  const [clientSearchResults, setClientSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [clientSelected, setClientSelected] = useState(false);
  const [fonti, setFonti] = useState([]);
  const [dettagliProvenienza, setDettagliProvenienza] = useState([]);
  const [loadingModal, setLoadingModal] = useState(false);
  const [vetture, setVetture] = useState([]);
  const [vettureSearchResults, setVettureSearchResults] = useState([]);
  const [vettureSearchTerm, setVettureSearchTerm] = useState('');
  const [vetturaSelected, setVetturaSelected] = useState(false);
  const [formData, setFormData] = useState({
    cliente: {
      id: '',
      nome: '',
      ragioneSociale: '',
      codiceFiscale: '',
      idCliente: '',
      status: ''
    },
    provenienza: {
      fonte: '',
      dettaglio: ''
    },
    vettura: {
      id: '',
      modello: '',
      brand: '',
      alimentazione: '',
      trasmissione: ''
    },
    dettagli: {
      dataCreazione: new Date().toISOString().split('T')[0],
      oraCreazione: new Date().toTimeString().slice(0, 5),
      note: ''
    }
  });

  // Carica i dati
  useEffect(() => {
    fetchLeads();
    setTimeout(() => setIsLoaded(true), 300);
  }, []);

  // Funzione per caricare le lead
  const fetchLeads = async () => {
    setLoading(true);
    try {
      const response = await api.get('/lead/all');
      if (response.data) {
        setLeads(response.data);
        setTotalResults(response.data.length);
      } else {
        setLeads([]);
        setTotalResults(0);
      }
      setLoading(false);
    } catch (error) {
      console.error('Errore nel caricamento delle lead:', error);
      setLeads([]);
      setTotalResults(0);
      setLoading(false);
    }
  };

  // Carica i dati iniziali per la modale
  useEffect(() => {
    if (showLeadModal) {
      const fetchData = async () => {
        try {
          const response = await api.get('/lead/fonti');
          setFonti(response.data.data || []);
        } catch (error) {
          console.error('Errore nel caricamento dei dati:', error);
        }
      };
      fetchData();
    }
  }, [showLeadModal]);
  
  // Carica i dettagli di provenienza quando cambia la fonte
  useEffect(() => {
    if (formData.provenienza.fonte) {
      const fetchDettagli = async () => {
        try {
          const response = await api.get(`/lead/dettagli-provenienza/${formData.provenienza.fonte}`);
          setDettagliProvenienza(response.data.data || []);
        } catch (error) {
          console.error('Errore nel caricamento dei dettagli:', error);
        }
      };
      fetchDettagli();
    } else {
      setDettagliProvenienza([]);
    }
  }, [formData.provenienza.fonte]);
  
  // Filtra i lead in base alla ricerca e ai filtri
  const filteredLeads = leads.filter(lead => {
    const matchesSearch = searchQuery === '' ||
      (lead.id && lead.id.toString().toLowerCase().includes(searchQuery.toLowerCase())) ||
      (lead.idCliente && lead.idCliente.toString().toLowerCase().includes(searchQuery.toLowerCase())) ||
      (lead.ragioneSociale && lead.ragioneSociale.toString().toLowerCase().includes(searchQuery.toLowerCase()));

    const matchesOrigin = originFilter === '' || lead.provenienza === originFilter;
    const matchesStatus = statusFilter === '' || 
      (statusFilter === 'nuovo' && !lead.isAssegnata && !lead.inLavorazione) ||
      (statusFilter === 'in_lavorazione' && lead.inLavorazione) ||
      (statusFilter === 'assegnata' && lead.isAssegnata);
    const matchesTemperature = temperatureFilter === '' || lead.temperaturaLead === temperatureFilter;

    return matchesSearch && matchesOrigin && matchesStatus && matchesTemperature;
  });

  // Reset dei filtri
  const resetFilters = () => {
    setOriginFilter('');
    setSourceFilter('');
    setStatusFilter('');
    setTemperatureFilter('');
    setSearchQuery('');
  };

  // Applica i filtri
  const applyFilters = () => {
    setShowFilters(false);
  };

  // Gestione creazione nuova opportunità
  const handleCreateNewLead = () => {
    setShowLeadModal(true);
    setStep(1);
    setFormData({
      cliente: {
        id: '',
        nome: '',
        ragioneSociale: '',
        codiceFiscale: '',
        idCliente: '',
        status: ''
      },
      provenienza: {
        fonte: '',
        dettaglio: ''
      },
      vettura: {
        id: '',
        modello: '',
        brand: '',
        alimentazione: '',
        trasmissione: ''
      },
      dettagli: {
        dataCreazione: new Date().toISOString().split('T')[0],
        oraCreazione: new Date().toTimeString().slice(0, 5),
        note: ''
      }
    });
    setClientSelected(false);
    setVetturaSelected(false);
    setVettureSearchTerm('');
    setVettureSearchResults([]);
  };

  // Cerca i clienti
  const searchClients = async (term) => {
    if (term.length < 3) {
      setClientSearchResults([]);
      return;
    }
    
    try {
      const response = await api.get(`/clienti/search?term=${term}`);
      setClientSearchResults(response.data);
    } catch (error) {
      console.error('Errore nella ricerca dei clienti:', error);
      setClientSearchResults([]);
    }
  };
  
  // Gestisce la modifica dei campi del form
  const handleInputChange = (section, field, value) => {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
  };
  
  // Seleziona un cliente
  const handleSelectClient = (client) => {
    setFormData(prev => ({
      ...prev,
      cliente: {
        id: client.id,
        nome: client.nome || '',
        cognome: client.cognome || '',
        ragioneSociale: client.ragione_sociale || client.ragioneSociale || '',
        codiceFiscale: client.codice_fiscale || client.codiceFiscale || '',
        idCliente: client.codice || client.idCliente || client.id,
        status: client.stato || client.status || 'Attivo'
      }
    }));
    setClientSelected(true);
    setClientSearchResults([]);
    setSearchTerm('');
  };
  
  // Rimuovi la selezione del cliente
  const handleRemoveClient = () => {
    setFormData(prev => ({
      ...prev,
      cliente: {
        id: '',
        nome: '',
        ragioneSociale: '',
        codiceFiscale: '',
        idCliente: '',
        status: ''
      }
    }));
    setClientSelected(false);
  };
  
  // Gestisce l'invio del form
  const handleSubmit = async (finalSubmit = false) => {
    if (step === 1 && !clientSelected) {
      toast.warning("Seleziona un cliente prima di continuare");
      return;
    }
    
    if (step === 2 && !formData.provenienza.fonte) {
      toast.warning("Seleziona una fonte prima di continuare");
      return;
    }
    
    if (step < 3 && !finalSubmit) {
      setStep(step + 1);
      return;
    }
    
    if (!formData.dettagli.dataCreazione || !formData.dettagli.oraCreazione) {
      toast.warning("Inserisci data e ora di creazione");
      return;
    }
    
    setLoadingModal(true);
    
    try {
      const dataToSend = {
        ...formData,
        ...(vetturaSelected && formData.vettura.id && {
          idVettura: formData.vettura.id
        })
      };
      
      const response = await api.post('/lead/create', dataToSend);
      console.log('Lead creata con successo:', response.data);
      
      setLoadingModal(false);
      setShowLeadModal(false);
      
      await fetchLeads();
      toast.success('Lead creata con successo!');
    } catch (error) {
      console.error('Errore nel salvataggio dei dati:', error);
      setLoadingModal(false);
      toast.error("Si è verificato un errore durante il salvataggio. Riprova.");
    }
  };
  
  // Reset del form
  const resetForm = () => {
    setFormData({
      cliente: {},
      provenienza: {
        fonte: '',
        dettaglio: ''
      },
      vettura: {},
      dettagli: {
        dataCreazione: '',
        oraCreazione: '',
        note: ''
      }
    });
    setClientSelected(false);
    setVetturaSelected(false);
    setStep(1);
  };

  // Chiudi la modale
  const closeLeadModal = () => {
    const confermaChiusura = () => {
      toast.dismiss();
      
      toast(
        ({ closeToast }) => (
          <div>
            <p className="mb-3">Sei sicuro di voler annullare? Tutti i dati inseriti andranno persi.</p>
            <div className="flex space-x-2">
              <button
                onClick={() => {
                  closeToast();
                  setShowLeadModal(false);
                  resetForm();
                }}
                className="px-3 py-1 bg-red-600 text-white rounded text-sm hover:bg-red-700"
              >
                Annulla e Perdi Dati
              </button>
              <button
                onClick={closeToast}
                className="px-3 py-1 bg-gray-300 text-gray-700 rounded text-sm hover:bg-gray-400"
              >
                Continua Modifica
              </button>
            </div>
          </div>
        ),
        {
          position: "top-center",
          autoClose: false,
          hideProgressBar: true,
          closeOnClick: false,
          draggable: false,
        }
      );
    };
    
    confermaChiusura();
  };

  // Apri dettaglio lead
  const handleOpenLeadDetail = (lead) => {
    console.log('Apertura dettaglio lead:', lead);
    setSelectedLead(lead);
    setShowDetailModal(true);
  };

  // Elimina una singola lead (solo admin)
  const handleDeleteLead = async (lead) => {
    const etichetta = lead.ragioneSociale && lead.ragioneSociale !== 'Cliente non trovato'
      ? lead.ragioneSociale : `#${lead.id}`;
    if (!window.confirm(`Eliminare definitivamente la lead ${etichetta}?\n\nL'operazione non è reversibile.`)) return;
    try {
      const response = await api.delete(`/lead/${lead.id}`);
      if (response.data?.success !== false) {
        toast.success('Lead eliminata');
        setLeads(prev => prev.filter(l => l.id !== lead.id));
      } else {
        toast.error(response.data?.error || 'Errore durante l\'eliminazione');
      }
    } catch (error) {
      const msg = error.response?.data?.error || 'Errore durante l\'eliminazione della lead';
      toast.error(msg);
    }
  };

  // Chiudi modale dettaglio
  const closeDetailModal = () => {
    setShowDetailModal(false);
    setSelectedLead(null);
  };

  // Funzione per ottenere l'URL dell'immagine della vettura
  const getVehicleImageUrl = (lead) => {
    if (lead.vettura && lead.vettura.immagine && lead.vettura.immagine.path_file) {
      return `${lead.vettura.immagine.path_file}`;
    }
    return null;
  };

  // Carica agenzie disponibili
  const caricaAgenzie = async () => {
    try {
      const response = await fetch('/api/pratica/agenzie');
      const data = await response.json();
      console.log('Agenzie caricate:', data);
      setAgenzieDisponibili(data.agenzie || []);
    } catch (error) {
      console.error('Errore nel caricamento agenzie:', error);
    }
  };

  // Gestione selezione multipla lead
  const handleSelectLead = (leadId) => {
    setSelectedLeads(prev => {
      if (prev.includes(leadId)) {
        return prev.filter(id => id !== leadId);
      } else {
        return [...prev, leadId];
      }
    });
  };

  // Seleziona/deseleziona tutte le lead
  const handleSelectAll = () => {
    if (selectedLeads.length === leads.filter(lead => !lead.isAssegnata).length && leads.filter(lead => !lead.isAssegnata).length > 0) {
      setSelectedLeads([]);
    } else {
      const leadNonAssegnate = leads.filter(lead => !lead.isAssegnata);
      setSelectedLeads(leadNonAssegnate.map(lead => lead.id));
    }
  };

  // Verifica se una lead è selezionata
  const isLeadSelected = (lead) => {
    return selectedLeads.includes(lead.id);
  };

  // Apri modale assegnazione
  const handleOpenAssignModal = (leadId = null) => {
    if (leadId) {
      setSelectedLeads([leadId]);
    }
    if (selectedLeads.length === 0 && !leadId) {
      toast.warning('Seleziona almeno una lead da assegnare');
      return;
    }
    setShowAssignModal(true);
    caricaAgenzie();
  };

  // Chiudi modale assegnazione
  const closeAssignModal = () => {
    setShowAssignModal(false);
    setSelectedLeads([]);
    setSelectedAgenzia('');
    setNoteAssegnazione('');
    setAgenzieSearchTerm('');
    setAgenzieOrderBy('nome');
  };

  // Esegui assegnazione
  const handleAssegnazione = async () => {
    if (!selectedAgenzia) {
      toast.warning('Seleziona un\'agenzia');
      return;
    }

    setLoadingAssegnazione(true);
    try {
      const endpoint = selectedLeads.length === 1 
        ? '/api/pratica/crea'
        : '/api/pratica/assegnazione-multipla';

      const payload = selectedLeads.length === 1
        ? {
            leadId: selectedLeads[0],
            agenziaId: parseInt(selectedAgenzia),
            note: noteAssegnazione
          }
        : {
            leadIds: selectedLeads,
            agenziaId: parseInt(selectedAgenzia),
            note: noteAssegnazione
          };

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(data.message || 'Assegnazione completata con successo!');
        closeAssignModal();
        closeDetailModal();
        setSelectedLeads([]);
        fetchLeads();
      } else {
        toast.error(data.error || 'Errore nell\'assegnazione');
      }
    } catch (error) {
      console.error('Errore nell\'assegnazione:', error);
      toast.error('Errore nell\'assegnazione');
    } finally {
      setLoadingAssegnazione(false);
    }
  };

  // Renderizza il termometro in base alla temperatura
  const renderTemperature = (temperatura) => {
    let color = '';
    let degrees = '';
    
    if (temperatura === 'Freddo') {
      color = 'text-blue-500';
      degrees = '-516gg';
    } else if (temperatura === 'Caldo') {
      color = 'text-red-500';
      degrees = '25h';
    } else if (temperatura === 'Tiepido') {
      color = 'text-yellow-500';
      degrees = '27h';
    }
    
    return (
      <div className="flex flex-col items-center">
        <svg className={`h-5 w-5 ${color}`} viewBox="0 0 24 24" fill="none">
          <path d="M12 20L4 8H20L12 20Z" fill="currentColor"/>
        </svg>
        <span className="text-xs text-gray-500">{degrees}</span>
      </div>
    );
  };

  // Cerca le vetture
  const searchVetture = async (term) => {
    if (term.length < 2) {
      setVettureSearchResults([]);
      return;
    }
    
    try {
      const response = await api.get(`/vehicles?search=${term}&limit=10`);
      const vetture = response.data.vehicles || response.data || [];
      setVettureSearchResults(vetture);
    } catch (error) {
      console.error('Errore nella ricerca delle vetture:', error);
      setVettureSearchResults([]);
    }
  };

  // Seleziona una vettura
  const handleSelectVettura = (vettura) => {
    setFormData(prev => ({
      ...prev,
      vettura: {
        id: vettura.id,
        modello: vettura.modello,
        brand: vettura.brand,
        alimentazione: vettura.alimentazione,
        trasmissione: vettura.trasmissione
      }
    }));
    setVetturaSelected(true);
    setVettureSearchResults([]);
    setVettureSearchTerm('');
  };

  // Rimuovi la selezione della vettura
  const handleRemoveVettura = () => {
    setFormData(prev => ({
      ...prev,
      vettura: {
        id: '',
        modello: '',
        brand: '',
        alimentazione: '',
        trasmissione: ''
      }
    }));
    setVetturaSelected(false);
  };

  // Gestione creazione cliente
  const handleOpenClientModal = () => {
    setShowClientModal(true);
    if (searchTerm) {
      const terms = searchTerm.split(' ');
      if (terms.length >= 2) {
        setClientFormData(prev => ({
          ...prev,
          nome: terms[0],
          cognome: terms.slice(1).join(' ')
        }));
      } else {
        setClientFormData(prev => ({
          ...prev,
          ragione_sociale: searchTerm
        }));
      }
    }
  };

  const handleCloseClientModal = () => {
    setShowClientModal(false);
    setClientFormData({
      tipo_cliente: 'privato',
      nome: '',
      cognome: '',
      ragione_sociale: '',
      codice_fiscale: '',
      partita_iva: '',
      email: '',
      telefono: '',
      indirizzo: '',
      citta: '',
      cap: '',
      provincia: '',
      note: ''
    });
  };

  const handleClientFormChange = (field, value) => {
    setClientFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleCreateClient = async () => {
    if (clientFormData.tipo_cliente === 'privato') {
      if (!clientFormData.nome || !clientFormData.cognome) {
        toast.error('Nome e cognome sono obbligatori per clienti privati');
        return;
      }
    } else {
      if (!clientFormData.ragione_sociale) {
        toast.error('Ragione sociale è obbligatoria per aziende');
        return;
      }
    }

    if (!clientFormData.email || !clientFormData.telefono) {
      toast.error('Email e telefono sono obbligatori');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(clientFormData.email)) {
      toast.error('Inserisci un indirizzo email valido');
      return;
    }

    if (clientFormData.telefono.length < 8 || clientFormData.telefono.length > 15) {
      toast.error('Il telefono deve essere tra 8 e 15 caratteri');
      return;
    }

    if (clientFormData.provincia && clientFormData.provincia.length !== 2) {
      toast.error('La provincia deve essere di 2 caratteri (es. MI, RM)');
      return;
    }

    if (clientFormData.cap && (clientFormData.cap.length !== 5 || !/^\d{5}$/.test(clientFormData.cap))) {
      toast.error('Il CAP deve essere di 5 cifre');
      return;
    }

    if (clientFormData.codice_fiscale && clientFormData.codice_fiscale.length !== 16) {
      toast.error('Il codice fiscale deve essere di 16 caratteri');
      return;
    }

    if (clientFormData.tipo_cliente === 'azienda' && clientFormData.partita_iva && 
        (clientFormData.partita_iva.length !== 11 || !/^\d{11}$/.test(clientFormData.partita_iva))) {
      toast.error('La partita IVA deve essere di 11 cifre');
      return;
    }

    setLoadingClientCreation(true);

    try {
      const dataToSend = { ...clientFormData };
      
      Object.keys(dataToSend).forEach(key => {
        if (dataToSend[key] === '' || 
            dataToSend[key] === null || 
            dataToSend[key] === undefined ||
            (typeof dataToSend[key] === 'string' && dataToSend[key].trim() === '')) {
          delete dataToSend[key];
        }
      });
      
      console.log('Dati da inviare:', dataToSend);
      
      const response = await api.post('/clienti', dataToSend);
      
      if (response.data) {
        const newClient = response.data;
        handleSelectClient({
          id: newClient.id,
          nome: newClient.nome,
          cognome: newClient.cognome,
          ragioneSociale: newClient.ragione_sociale,
          codiceFiscale: newClient.codice_fiscale,
          idCliente: newClient.codice,
          status: newClient.stato
        });
        
        handleCloseClientModal();
        toast.success('Cliente creato con successo!');
      }
    } catch (error) {
      console.error('Errore nella creazione del cliente:', error);
      
      if (error.response && error.response.data && error.response.data.errors) {
        const errors = error.response.data.errors;
        const errorMessages = errors.map(err => err.msg).join('\n');
        toast.error(`Errori di validazione:\n${errorMessages}`);
      } else {
        toast.error('Errore nella creazione del cliente. Riprova.');
      }
    } finally {
      setLoadingClientCreation(false);
    }
  };

  return (
    <div className="h-screen overflow-hidden bg-gradient-to-br from-gray-50 via-white to-blue-50/30">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(0,122,255,0.05)_1px,transparent_0)] [background-size:24px_24px] pointer-events-none" />
      
      <div className="relative z-10 h-full flex flex-col px-6 py-6">
        {/* Header Section */}
        <div className={`flex-shrink-0 transition-all duration-1000 ease-out ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="bg-white/70 backdrop-blur-xl rounded-3xl p-6 border border-white/20 shadow-xl shadow-black/5 mb-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="relative">
                  <div className="w-16 h-16 bg-gradient-to-br from-orange-500 via-orange-600 to-red-600 rounded-2xl flex items-center justify-center shadow-2xl shadow-orange-500/25">
                    <SparklesIcon className="h-8 w-8 text-white" />
                  </div>
                  <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-white flex items-center justify-center">
                    <div className="w-1.5 h-1.5 bg-white rounded-full"></div>
                  </div>
                </div>
                <div>
                  <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-gray-900 via-gray-800 to-gray-700 bg-clip-text text-transparent mb-1">
                    Gestione Lead
                  </h1>
                  <p className="text-gray-600 font-medium">
                    Gestisci le opportunità commerciali
                  </p>
                </div>
              </div>
              <div className="hidden sm:flex items-center space-x-3">
                <div className="text-right">
                  <div className="text-sm text-gray-500 font-medium">Lead Totali</div>
                  <div className="text-2xl font-bold text-gray-900">{totalResults}</div>
                </div>
                <div className="text-right">
                  <div className="text-sm text-gray-500 font-medium">Selezionate</div>
                  <div className="text-2xl font-bold text-blue-600">{selectedLeads.length}</div>
                </div>
              </div>
            </div>
        </div>
      </div>
      
        {/* Action Bar */}
        <div className={`flex-shrink-0 transition-all duration-1000 ease-out delay-200 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="bg-white/70 backdrop-blur-xl rounded-2xl p-4 border border-white/20 shadow-lg shadow-black/5 mb-6">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
              {/* Search Bar */}
              <div className="relative flex-1 max-w-md">
            <input
              type="text"
              placeholder="Cerca per ID, cliente..."
              className="w-full pl-10 pr-4 py-2.5 border border-gray-200/50 rounded-xl bg-white/70 backdrop-blur-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500/50 transition-all duration-200 placeholder-gray-400"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <MagnifyingGlassIcon className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
          </div>
          
              {/* Action Buttons */}
              <div className="flex items-center gap-3">
                          <button
                  className="inline-flex items-center px-4 py-2.5 border border-gray-200/50 shadow-sm text-sm font-semibold rounded-xl text-gray-700 bg-white/80 backdrop-blur-sm hover:bg-white/95 hover:shadow-lg hover:border-gray-300/50 transition-all duration-200"
                  onClick={() => setShowFilters(!showFilters)}
                >
                  <FunnelIcon className="h-5 w-5 mr-2 text-gray-600" />
                  Filtri
                  {(originFilter || statusFilter || temperatureFilter) && (
                    <span className="ml-2 px-2 py-1 bg-blue-500 text-white text-xs rounded-full font-medium shadow-sm">
                      Attivi
                    </span>
                  )}
                </button>
                
                <Link
                  to="/nlt/lead/fonti-provenienza"
                  className="inline-flex items-center px-4 py-2.5 border border-gray-200/50 shadow-sm text-sm font-semibold rounded-xl text-gray-700 bg-white/80 backdrop-blur-sm hover:bg-white/95 hover:shadow-lg hover:border-gray-300/50 transition-all duration-200"
                >
                  <AdjustmentsHorizontalIcon className="h-5 w-5 mr-2 text-gray-600" />
                  Gestione Fonti
                </Link>
                
                {selectedLeads.length > 0 && (
                  <button
                    onClick={() => handleOpenAssignModal()}
                    className="inline-flex items-center px-4 py-2.5 border border-transparent shadow-sm text-sm font-semibold rounded-xl text-white bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 hover:shadow-md transition-all duration-200"
                  >
                    <CheckCircleIcon className="h-5 w-5 mr-2" />
                    Assegna {selectedLeads.length} Lead
                  </button>
                )}
                
                <button
                  onClick={handleCreateNewLead}
                  className="inline-flex items-center px-4 py-2.5 border border-transparent shadow-sm text-sm font-semibold rounded-xl text-white bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 hover:shadow-md transition-all duration-200"
                >
                  <PlusIcon className="h-5 w-5 mr-2" />
                  Nuova Lead
                </button>
              </div>
            </div>
          </div>
        </div>
        
        {/* Filters Section */}
        {showFilters && (
          <div className={`flex-shrink-0 transition-all duration-500 ease-out ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="bg-white/70 backdrop-blur-xl rounded-2xl p-6 border border-white/20 shadow-lg shadow-black/5 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                  Provenienza
                </label>
                <select
                  className="w-full p-2.5 border border-gray-200/50 rounded-xl bg-white/70 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500/50 transition-all duration-200"
                  value={originFilter}
                  onChange={(e) => setOriginFilter(e.target.value)}
                >
                  <option value="">Tutte le provenienze</option>
                  <option value="Sito Web">Sito Web</option>
                  <option value="Telefono">Telefono</option>
                  <option value="Email">Email</option>
                  <option value="Social Media">Social Media</option>
                  <option value="Referral">Referral</option>
                  <option value="Lead Esterni">Lead Esterni</option>
                </select>
              </div>

              <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                  Stato
                </label>
                <select
                  className="w-full p-2.5 border border-gray-200/50 rounded-xl bg-white/70 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500/50 transition-all duration-200"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="">Tutti gli stati</option>
                  <option value="nuovo">Nuovo</option>
                  <option value="in_lavorazione">In Lavorazione</option>
                  <option value="assegnata">Assegnata</option>
                </select>
              </div>

              <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                  Temperatura
                </label>
                <select
                  className="w-full p-2.5 border border-gray-200/50 rounded-xl bg-white/70 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500/50 transition-all duration-200"
                  value={temperatureFilter}
                  onChange={(e) => setTemperatureFilter(e.target.value)}
                >
                  <option value="">Tutte le temperature</option>
                  <option value="Caldo">🔥 Caldo</option>
                  <option value="Tiepido">🌡️ Tiepido</option>
                  <option value="Freddo">❄️ Freddo</option>
                </select>
              </div>

              <div className="flex items-end space-x-2">
                                  <button
                    onClick={applyFilters}
                    className="flex-1 px-3 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-sm font-semibold rounded-xl hover:from-blue-700 hover:to-blue-800 hover:shadow-lg transition-all duration-200 shadow-md"
                  >
                    Applica
                  </button>
                  <button
                    onClick={resetFilters}
                    className="flex-1 px-3 py-2.5 bg-white/90 backdrop-blur-sm border border-gray-300/50 text-gray-700 text-sm font-semibold rounded-xl hover:bg-white hover:shadow-lg hover:border-gray-400/50 transition-all duration-200 shadow-sm"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        
        {/* Main Content */}
        <div className={`flex-1 transition-all duration-1000 ease-out delay-400 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'} min-h-0`}>
          <div className="bg-white/70 backdrop-blur-xl rounded-3xl border border-white/20 shadow-xl shadow-black/5 h-full flex flex-col">
            {/* Results Info */}
            <div className="flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-gray-100/50">
          <div className="text-sm text-gray-600">
                Mostrando <span className="font-medium text-gray-900">{filteredLeads.length}</span> di <span className="font-medium text-gray-900">{leads.length}</span> lead
            {(originFilter || statusFilter || temperatureFilter || searchQuery) && (
                  <span className="ml-2 text-blue-600 font-medium">(filtrate)</span>
            )}
          </div>
          {(originFilter || statusFilter || temperatureFilter || searchQuery) && (
                            <button
                  onClick={resetFilters}
                  className="text-sm text-blue-600 hover:text-blue-800 font-medium hover:underline transition-all duration-200 px-3 py-1 rounded-lg hover:bg-blue-50"
                >
                  Rimuovi tutti i filtri
                </button>
          )}
        </div>
        
            {/* Content */}
            <div className="flex-1 overflow-hidden">
        {loading ? (
                <div className="h-full flex items-center justify-center">
                  <div className="text-center">
                    <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                    <p className="text-gray-500 mt-4">Caricamento in corso...</p>
                  </div>
          </div>
        ) : filteredLeads.length > 0 ? (
                <div className="h-full overflow-auto apple-scrollbar">
                  {/* Desktop View */}
                  <div className="hidden sm:block">
                    {/* Header */}
                    <div className="sticky top-0 bg-gradient-to-r from-gray-50/90 to-white/90 backdrop-blur-sm px-6 py-4 border-b border-gray-100/50 z-10">
                      <div className="grid grid-cols-12 gap-3 text-xs font-medium text-gray-500 uppercase tracking-wider">
                  <div className="col-span-1 flex items-center">
                                              <input
                            type="checkbox"
                            checked={selectedLeads.length === leads.filter(lead => !lead.isAssegnata).length && leads.filter(lead => !lead.isAssegnata).length > 0}
                            onChange={handleSelectAll}
                            className="mr-2 h-4 w-4 text-blue-600 focus:ring-blue-500 focus:ring-2 border-gray-400 rounded shadow-sm"
                          />
                          Sel.
                  </div>
                  <div className="col-span-2">ID Lead</div>
                        <div className="col-span-2">Data</div>
                  <div className="col-span-2">Cliente</div>
                        <div className="col-span-2">Provenienza</div>
                  <div className="col-span-1">Temp.</div>
                  <div className="col-span-1">Stato</div>
                  <div className="col-span-1 text-center">Azioni</div>
                </div>
              </div>
              
                    {/* Rows */}
                    <div className="divide-y divide-gray-100/50">
              {filteredLeads.map((lead) => (
                        <div key={lead.id} className={`group hover:bg-gradient-to-r hover:from-blue-50/30 hover:to-white/30 transition-all duration-200 ${
                          isLeadSelected(lead) ? 'bg-gradient-to-r from-blue-50/50 to-blue-100/30 border-l-4 border-l-blue-500' : ''
                } ${lead.isAssegnata ? 'border-l-4 border-l-green-500/80' : ''}`}>
                  <div className="px-6 py-4">
                            <div className="grid grid-cols-12 gap-3 items-center">
                                                            <div className="col-span-1 flex items-center">
                                <input
                                  type="checkbox"
                                  checked={isLeadSelected(lead)}
                                  onChange={() => handleSelectLead(lead.id)}
                                  disabled={lead.isAssegnata}
                                  className={`h-4 w-4 text-blue-600 focus:ring-blue-500 focus:ring-2 border-gray-400 rounded shadow-sm ${
                                    lead.isAssegnata ? 'opacity-50 cursor-not-allowed' : ''
                                  }`}
                                />
                              </div>
                      
                      <div className="col-span-2">
                                <div className="text-sm font-bold text-blue-600">
                          LEAD {lead.id.toString().padStart(8, '0')}
                                </div>
                          {lead.idPratica && (
                            <div className="text-green-600 text-xs font-semibold mt-1">
                              {lead.idPratica}
                            </div>
                          )}
                      </div>
                      
                              <div className="col-span-2">
                                <div className="text-sm font-medium text-gray-900">{lead.dataCreazione}</div>
                        <div className="text-xs text-gray-500">{lead.tempoTrascorso}</div>
                      </div>
                      
                      <div className="col-span-2">
                                <div className="text-sm font-medium text-gray-900 truncate">{lead.ragioneSociale}</div>
                                <div className="text-xs text-gray-500">
                          {lead.cliente?.tipo_cliente === 'privato' ? 'Privato' : 'Azienda'}
                        </div>
                      </div>
                      
                              <div className="col-span-2">
                                <div className="text-sm font-medium text-gray-900">{lead.provenienza || 'Non specificata'}</div>
                                {lead.dettaglioProvenienza && (
                                  <div className="text-xs text-gray-500 truncate">{lead.dettaglioProvenienza}</div>
                        )}
                      </div>
                      
                                                            <div className="col-span-1 flex justify-center">
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center shadow-lg ${
                                  lead.temperaturaLead === 'Caldo' ? 'bg-gradient-to-br from-red-500 to-red-600' : 
                                  lead.temperaturaLead === 'Tiepido' ? 'bg-gradient-to-br from-yellow-500 to-yellow-600' : 
                                  'bg-gradient-to-br from-blue-500 to-blue-600'
                                }`}>
                                  {lead.temperaturaLead === 'Caldo' ? (
                                    <FireIcon className="h-4 w-4 text-white" />
                                  ) : lead.temperaturaLead === 'Tiepido' ? (
                                    <SparklesIcon className="h-4 w-4 text-white" />
                                  ) : (
                                    <div className="w-3 h-3 bg-white rounded-full"></div>
                                  )}
                                </div>
                              </div>
                      
                      <div className="col-span-1">
                        <div className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${
                          lead.isAssegnata ? 'bg-green-100 text-green-700' :
                          lead.inLavorazione ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700'
                        }`}>
                                  {lead.isAssegnata ? 'Assegnata' : 
                                   lead.inLavorazione ? 'In Lavorazione' : 'Nuovo'}
                        </div>
                      </div>
                      
                                                    <div className="col-span-1 flex justify-center space-x-1">
                                <button 
                                  className="p-2 text-white bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 rounded-lg transition-all duration-200 shadow-sm hover:shadow-md hover:scale-105"
                                  onClick={() => handleOpenLeadDetail(lead)}
                                  title="Visualizza dettaglio"
                                >
                                  <EyeIcon className="h-4 w-4" />
                                </button>
                                {!lead.isAssegnata && (
                                  <button
                                    className="p-2 text-white bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 rounded-lg transition-all duration-200 shadow-sm hover:shadow-md hover:scale-105"
                                    onClick={() => handleOpenAssignModal(lead.id)}
                                    title="Assegna lead"
                                  >
                                    <CheckCircleIcon className="h-4 w-4" />
                                  </button>
                                )}
                                {isAdmin && (
                                  <button
                                    className="p-2 text-white bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 rounded-lg transition-all duration-200 shadow-sm hover:shadow-md hover:scale-105"
                                    onClick={() => handleDeleteLead(lead)}
                                    title="Elimina lead"
                                  >
                                    <TrashIcon className="h-4 w-4" />
                                  </button>
                                )}
                              </div>
                    </div>
                  </div>
                </div>
              ))}
                    </div>
            </div>

                  {/* Mobile View */}
                  <div className="sm:hidden p-4 space-y-4">
              {filteredLeads.map((lead) => (
                      <div key={lead.id} className={`bg-white/80 rounded-2xl border p-4 shadow-sm ${
                        isLeadSelected(lead) ? 'border-blue-300 bg-blue-50/50' : 'border-gray-200/50'
                } ${lead.isAssegnata ? 'border-l-4 border-l-green-500' : ''}`}>
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex items-center space-x-3">
                                                  <input
                              type="checkbox"
                              checked={isLeadSelected(lead)}
                              onChange={() => handleSelectLead(lead.id)}
                              disabled={lead.isAssegnata}
                              className={`h-4 w-4 text-blue-600 focus:ring-blue-500 focus:ring-2 border-gray-400 rounded shadow-sm ${
                                lead.isAssegnata ? 'opacity-50 cursor-not-allowed' : ''
                              }`}
                            />
                      <div>
                              <div className="text-sm font-bold text-blue-600">
                          LEAD {lead.id.toString().padStart(8, '0')}
                        </div>
                        {lead.idPratica && (
                          <div className="text-green-600 text-xs font-semibold">
                            {lead.idPratica}
                          </div>
                        )}
                      </div>
                    </div>
                                              <div className="flex items-center space-x-2">
                            <div className={`w-6 h-6 rounded-full flex items-center justify-center shadow-sm ${
                              lead.temperaturaLead === 'Caldo' ? 'bg-gradient-to-br from-red-500 to-red-600' : 
                              lead.temperaturaLead === 'Tiepido' ? 'bg-gradient-to-br from-yellow-500 to-yellow-600' : 
                              'bg-gradient-to-br from-blue-500 to-blue-600'
                            }`}>
                              {lead.temperaturaLead === 'Caldo' ? (
                                <FireIcon className="h-3 w-3 text-white" />
                              ) : lead.temperaturaLead === 'Tiepido' ? (
                                <SparklesIcon className="h-3 w-3 text-white" />
                              ) : (
                                <div className="w-2 h-2 bg-white rounded-full"></div>
                              )}
                            </div>
                            <button 
                              className="p-2 text-white bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 rounded-lg transition-all duration-200 shadow-sm hover:shadow-md"
                              onClick={() => handleOpenLeadDetail(lead)}
                              title="Visualizza dettaglio"
                            >
                              <EyeIcon className="h-4 w-4" />
                            </button>
                            {!lead.isAssegnata && (
                              <button
                                className="p-2 text-white bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 rounded-lg transition-all duration-200 shadow-sm hover:shadow-md"
                                onClick={() => handleOpenAssignModal(lead.id)}
                                title="Assegna lead"
                              >
                                <CheckCircleIcon className="h-4 w-4" />
                              </button>
                            )}
                            {isAdmin && (
                              <button
                                className="p-2 text-white bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 rounded-lg transition-all duration-200 shadow-sm hover:shadow-md"
                                onClick={() => handleDeleteLead(lead)}
                                title="Elimina lead"
                              >
                                <TrashIcon className="h-4 w-4" />
                              </button>
                            )}
                          </div>
                  </div>

                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                            <span className="text-gray-500 font-medium">Cliente:</span>
                            <span className="font-medium text-gray-900">{lead.ragioneSociale}</span>
                    </div>
                    <div className="flex justify-between">
                            <span className="text-gray-500 font-medium">Data:</span>
                            <span className="text-gray-900">{lead.dataCreazione}</span>
                    </div>
                    <div className="flex justify-between">
                            <span className="text-gray-500 font-medium">Provenienza:</span>
                            <span className="text-gray-900">{lead.provenienza || 'Non specificata'}</span>
                    </div>
                          <div className="flex justify-between items-center">
                            <span className="text-gray-500 font-medium">Stato:</span>
                      <div className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${
                        lead.isAssegnata ? 'bg-green-100 text-green-700' :
                        lead.inLavorazione ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700'
                      }`}>
                        {lead.isAssegnata ? 'Assegnata' : 
                               lead.inLavorazione ? 'In Lavorazione' : 'Nuovo'}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
                <div className="h-full flex items-center justify-center">
                  <div className="text-center py-12">
                    <div className="w-24 h-24 mx-auto mb-4 bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl flex items-center justify-center">
                      <SparklesIcon className="h-12 w-12 text-gray-400" />
          </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Nessuna lead trovata</h3>
                    <p className="text-gray-500 mb-6">Non ci sono lead che corrispondono ai criteri di ricerca.</p>
                                      <button
                      onClick={handleCreateNewLead}
                      className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl hover:from-blue-700 hover:to-blue-800 hover:shadow-lg hover:scale-105 transition-all duration-200 shadow-md"
                    >
                      <PlusIcon className="h-5 w-5 mr-2" />
                      Crea Prima Lead
                    </button>
                                </div>
                              </div>
                            )}
                          </div>
                      </div>
                            </div>
                            </div>

      {/* Modals */}
      <LeadModals
        // Modal states
        showLeadModal={showLeadModal}
        showClientModal={showClientModal}
        showDetailModal={showDetailModal}
        showAssignModal={showAssignModal}
        
        // Modal handlers
        closeLeadModal={closeLeadModal}
        handleCloseClientModal={handleCloseClientModal}
        closeDetailModal={closeDetailModal}
        closeAssignModal={closeAssignModal}
        
        // Form data and handlers
        step={step}
        setStep={setStep}
        formData={formData}
        handleInputChange={handleInputChange}
        clientSelected={clientSelected}
        vetturaSelected={vetturaSelected}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        clientSearchResults={clientSearchResults}
        searchClients={searchClients}
        handleSelectClient={handleSelectClient}
        handleRemoveClient={handleRemoveClient}
        fonti={fonti}
        dettagliProvenienza={dettagliProvenienza}
        vettureSearchTerm={vettureSearchTerm}
        setVettureSearchTerm={setVettureSearchTerm}
        vettureSearchResults={vettureSearchResults}
        searchVetture={searchVetture}
        handleSelectVettura={handleSelectVettura}
        handleRemoveVettura={handleRemoveVettura}
        handleSubmit={handleSubmit}
        loadingModal={loadingModal}
        
        // Client modal
        clientFormData={clientFormData}
        handleClientFormChange={handleClientFormChange}
        handleCreateClient={handleCreateClient}
        loadingClientCreation={loadingClientCreation}
        handleOpenClientModal={handleOpenClientModal}
        
        // Detail modal
        selectedLead={selectedLead}
        getVehicleImageUrl={getVehicleImageUrl}
        handleOpenAssignModal={handleOpenAssignModal}
        
        // Assignment modal
        selectedLeads={selectedLeads}
        agenzieDisponibili={agenzieDisponibili}
        selectedAgenzia={selectedAgenzia}
        setSelectedAgenzia={setSelectedAgenzia}
        noteAssegnazione={noteAssegnazione}
        setNoteAssegnazione={setNoteAssegnazione}
        agenzieSearchTerm={agenzieSearchTerm}
        setAgenzieSearchTerm={setAgenzieSearchTerm}
        agenzieOrderBy={agenzieOrderBy}
        setAgenzieOrderBy={setAgenzieOrderBy}
        handleAssegnazione={handleAssegnazione}
        loadingAssegnazione={loadingAssegnazione}
      />
    </div>
  );
};

export default LeadPage;